/**
 * Brand Logo component — uses the official Grow And Stay Rich logo.
 *
 * Props:
 *   size    "xs" | "sm" | "md" | "lg" | "xl"  — controls rendered height
 *   onDark  boolean — when true, renders the gold-on-dark version
 *   className — extra Tailwind/CSS classes on the wrapper
 */
export default function Logo({ className = '', size = 'md', onDark = false }) {
  const heights = {
    xs: 30,
    sm: 44,   // agents header (h-14 = 56px) — leaves comfortable room
    md: 52,   // main navigation
    lg: 68,   // login / landing hero
    xl: 88,
  };
  const h = heights[size] || 40;

  if (onDark) {
    return (
      <div
        className={`inline-flex items-center ${className}`}
        style={{ height: h }}
      >
        <img
          src="/images/logo/logo-horizontal-white.svg"
          alt="Grow And Stay Rich"
          style={{
            height: h,
            width: 'auto',
            objectFit: 'contain',
          }}
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center ${className}`} style={{ height: h }}>
      <img
        src="/images/logo/logo-horizontal-royalblue.svg"
        alt="Grow And Stay Rich"
        style={{
          height: h,
          width: 'auto',
          objectFit: 'contain',
        }}
        draggable={false}
      />
    </div>
  );
}
